/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconLink8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconLink8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M3.64 2.945a1 1 0 0 0 0 1.414l-.471.471a1.667 1.667 0 0 1 0-2.357l1.178-1.178a1.667 1.667 0 1 1 2.357 2.357L6 4.356l-.131-.811.364-.365a1 1 0 1 0-1.414-1.414L3.64 2.945Zm.707 2.12a1 1 0 0 0 0-1.414l.472-.471c.65.65.65 1.706 0 2.357L3.652 6.704a1.667 1.667 0 0 1-2.357-2.357L2 3.642l.108.834-.342.342A1 1 0 0 0 3.18 6.232l1.167-1.166Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconLink16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconLink16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M7.28 5.89a2 2 0 0 0 0 2.828l-.942.943a3.333 3.333 0 0 1 0-4.714L8.695 2.59a3.333 3.333 0 0 1 4.714 4.714L12 8.712l-.263-1.623.729-.728a2 2 0 0 0-2.829-2.829L7.28 5.89Zm1.414 4.241a2 2 0 0 0 0-2.828l.943-.943a3.333 3.333 0 0 1 0 4.714l-2.333 2.334A3.333 3.333 0 1 1 2.59 8.694L4 7.284l.216 1.669-.684.683a2 2 0 1 0 2.829 2.829l2.333-2.334Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconLink20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconLink20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M9.1 7.362a2.5 2.5 0 0 0 0 3.535l-1.178 1.179a4.167 4.167 0 0 1 0-5.893l2.946-2.946a4.167 4.167 0 1 1 5.893 5.893L15 10.89l-.328-2.028.91-.911a2.5 2.5 0 0 0-3.535-3.535L9.1 7.361Zm1.768 5.302a2.5 2.5 0 0 0 0-3.535l1.178-1.179a4.167 4.167 0 0 1 0 5.893L9.13 16.759a4.167 4.167 0 1 1-5.893-5.892L5 9.104l.27 2.087-.854.854a2.5 2.5 0 1 0 3.535 3.536l2.917-2.917Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconLink24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconLink24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M10.92 8.834a3 3 0 0 0 0 4.243L9.507 14.49a5 5 0 0 1 0-7.071l3.536-3.536a5 5 0 0 1 7.07 7.072L18 13.068l-.394-2.434 1.093-1.093A3 3 0 1 0 14.456 5.3l-3.535 3.535Zm2.121 6.363a3 3 0 0 0 0-4.243l1.415-1.414a5 5 0 0 1 0 7.071l-3.5 3.5a5 5 0 0 1-7.072-7.07L6 10.924l.324 2.504-1.025 1.025a3 3 0 1 0 4.242 4.243l3.5-3.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconLink = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconLink(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconLink8 {...iconProps} />;
        case '16':
            return <IconLink16 {...iconProps} />;
        case '20':
            return <IconLink20 {...iconProps} />;
        case '24':
            return <IconLink24 {...iconProps} />;
        default:
            return <IconLink24 {...iconProps} />;
    }
});
